<template>
    <div>
        <p class="text-center">
            För att skydda dina personuppgifter har vi skickat en kod till dig
            via SMS/epost. Den behöver du mata in nedan för att gå vidare.
            <br />
            (Tips. Du kan oftast helt enkelt klicka i fältet och så kommer koden
            klistras in)
        </p>

        <axios-form
            class="mb-3"
            method="post"
            :action="route('model_authentication.authenticate', codeKey)"
            @submit="onAuthenticateSubmit"
            @success="onAuthenticateSuccess"
            @failure="onAuthenticateFailure"
        >
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="input-code"
                        ><i class="fa-regular fa-input-numeric"></i
                    ></label>
                </div>
                <input
                    class="form-control"
                    type="text"
                    inputmode="numeric"
                    required
                    pattern="[0-9]+"
                    autocomplete="one-time-code"
                    name="code"
                    id="input-code"
                    v-model="code"
                />
            </div>

            <button class="btn btn-outline-primary w-100" type="submit">
                Gå vidare
            </button>

            <p v-if="authenticationFailure" class="mt-2 text-danger">
                Inkorrekt kod, försök igen!
            </p>
        </axios-form>
    </div>
</template>

<style scoped></style>

<script setup>
import { ref } from "vue";
import { route } from "ziggy";

defineProps({
    codeKey: { type: String, required: true },
});

const code = ref(undefined);
const authenticationFailure = ref(false);

function onAuthenticateSubmit() {
    authenticationFailure.value = false;
}
function onAuthenticateSuccess(response) {
    document.location.href = response.data.return_url;
}
function onAuthenticateFailure() {
    authenticationFailure.value = true;
}
</script>
